import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { DashboardState, DashboardPerformanceData, LineGraphData, RevenueChartData } from "./types";
import { fetchDashboardAnalytics, fetchLineGraphData, fetchRevenueChartData, fetchUsers } from "./actions";

const initialState: DashboardState = {
    perFormanceData: null,
    loading: "idle",
    error: null,
    lineGraphData: null,
    lineGraphLoading: "idle",
    lineGraphError: null,
    revenueChartData: null,
    revenueChartLoading: "idle",
    revenueChartError: null,
    users: null,
    usersLoading: "idle",
    usersError: null,
  };

const dashboardSlice = createSlice({
    name: "dashboard",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
      builder
        .addCase(fetchDashboardAnalytics.pending, (state) => {
          state.loading = "pending";
          state.error = null;
        })
        .addCase(
          fetchDashboardAnalytics.fulfilled,
          (state, action: PayloadAction<DashboardPerformanceData>) => {
            state.loading = "succeeded";
            state.perFormanceData = action.payload;
          }
        )
        .addCase(fetchDashboardAnalytics.rejected, (state, action: PayloadAction<any>) => {
          state.loading = "failed";
          state.error = action.payload?.message || "Failed to fetch dashboard analytics data";
        })
  
        .addCase(fetchLineGraphData.pending, (state) => {
          state.lineGraphLoading = "pending";
          state.lineGraphError = null;
        })
        .addCase(
          fetchLineGraphData.fulfilled,
          (state, action: PayloadAction<LineGraphData>) => {
            state.lineGraphLoading = "succeeded";
            state.lineGraphData = action.payload;
          }
        )
        .addCase(fetchLineGraphData.rejected, (state, action: PayloadAction<any>) => {
          state.lineGraphLoading = "failed";
          state.lineGraphError = action.payload?.message || "Failed to fetch line graph data";
        })
  
        .addCase(fetchRevenueChartData.pending, (state) => {
          state.revenueChartLoading = "pending";
          state.revenueChartError = null;
        })
        .addCase(
          fetchRevenueChartData.fulfilled,
          (state, action: PayloadAction<RevenueChartData>) => {
            state.revenueChartLoading = "succeeded";
            state.revenueChartData = action.payload;
          }
        )
        .addCase(fetchRevenueChartData.rejected, (state, action: PayloadAction<any>) => {
          state.revenueChartLoading = "failed";
          state.revenueChartError = action.payload?.message || "Failed to fetch revenue chart data";
        })

        .addCase(fetchUsers.pending, (state) => {
          state.usersLoading = 'pending';
          state.usersError = null;
        })
        .addCase(fetchUsers.fulfilled, (state, action: PayloadAction<any>) => {
          state.usersLoading = 'succeeded';
          state.users = action.payload;
        })
        .addCase(fetchUsers.rejected, (state, action) => {
          state.usersLoading = 'failed';
          state.usersError = action.error.message || 'Failed to fetch users';
        });
    },
  });
  
  export default dashboardSlice.reducer;
  